import React, { useEffect, useState } from "react";

import { getShapefileRegions, useCancelAsyncOnUnmount } from "utils";

import { AdminSection, Col, Option, Row, Select } from "components";

export const NotificationUserSegment = ({ articles, methods, notification, t }) => {
  const roleEnums = t("enums:roles", { returnObjects: true });
  const [regionEnums, setRegionEnums] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  useEffect(() => {
    getShapefileRegions({ signal }).then((regionEnums) => {
      setRegionEnums(regionEnums);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <AdminSection
        headline="User segment"
        description={
          <>
            Select the user segmentation options.{" "}
            <b>Users will be matched to ALL of the segments you select, but will match one of the items in each segmentation type</b>. For example, if you
            select verified users and two regions, any verified user who is one of those regions will be included. If you want to ignore an option, select the
            "any" option in the segment.
          </>
        }
      />
      <Row>
        <Col sm={12} md={8}>
          <Select name="userVerification" rules={[{ required: true }]} label="Verification" initialValue={notification && notification.userVerification}>
            <Option value="all">Any verification</Option>
            <Option value="verified">Verified</Option>
            <Option value="unverified">Unverified</Option>
          </Select>
        </Col>
        <Col sm={12} md={8}>
          <Select
            name="userActivity"
            rules={[{ required: true }]}
            label="Activity"
            popupMatchSelectWidth={false}
            initialValue={notification && notification.userActivity}
          >
            <Option value="all">Any activity</Option>
            <Option value="active-7">Active in last 7 days</Option>
            <Option value="active-30">Active in last 30 days</Option>
            <Option value="inactive-7">Inactive in last 7 days</Option>
            <Option value="inactive-30">Inactive in last 30 days</Option>
          </Select>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={8}>
          <Select name="userRole" label="Role" rules={[{ required: true }]} popupMatchSelectWidth={false} initialValue={notification && notification.userRole}>
            <Option value="all">Any role</Option>
            {Object.keys(roleEnums).map((item, i) => (
              <Option value={item} key={i}>
                {roleEnums[item]}
              </Option>
            ))}
          </Select>
        </Col>
        <Col sm={12} md={12}>
          <Select
            name="userRegions"
            label="Regions"
            rules={[{ required: true }]}
            popupMatchSelectWidth={false}
            mode="multiple"
            initialValue={notification && notification.userRegions}
          >
            <Option value="all">Any region</Option>
            {Object.keys(regionEnums).map((item, i) => (
              <Option value={regionEnums[item]} key={i}>
                {regionEnums[item]}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={16}>
          <Select
            name="userMethods"
            rules={[{ required: true }]}
            label="Methods"
            popupMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            mode="multiple"
            initialValue={notification && notification.userMethods}
          >
            <Option value="all">Any method</Option>
            <Option value="never">Never had a method</Option>
            <Option value="inactive">No active methods</Option>
            <Option value="active">At least one active method</Option>
            {methods.map((item, i) => (
              <Option value={item} key={i}>
                {item} active
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={12}>
          <Select
            name="userRecommendedMethods"
            rules={[{ required: true }]}
            label="Recommended methods"
            popupMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            mode="multiple"
            initialValue={notification ? notification.userRecommendedMethods : ["all"]}
            disabled
          >
            <Option value="all">Any method</Option>
            {methods.map((item, i) => (
              <Option value={item} key={i}>
                {item}
              </Option>
            ))}
          </Select>
        </Col>
        <Col sm={24} md={12}>
          <Select
            name="userRecommendedArticles"
            rules={[{ required: true }]}
            label="Recommended articles"
            popupMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            mode="multiple"
            initialValue={notification ? notification.userRecommendedArticles : ["all"]}
          >
            <Option value="all">Any article</Option>
            {articles.map((item, i) => (
              <Option value={item.id} key={i}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </>
  );
};
